/* ============================================
   NKOSI Custom Scripts
   ============================================ */

/* ========================================
   Judge.me - English locale overrides
   (mirrors French T-Lab custom texts for EN)
   ======================================== */
(function () {
  "use strict";
  var locale = (window.Shopify && window.Shopify.locale) || "";
  if (locale !== "en") return;

  function applyEN() {
    var s = window.jdgmSettings;
    if (!s) return;
    /* Featured carousel */
    s.featured_carousel_title            = "They love NKOSI.";
    s.featured_carousel_count_text       = "Rated 4.7/5 \u2b50 ({{ n }} reviews)"; /* Marché Collage S1 2026-09-26 : note réelle Judge.me 4,69 */
    s.featured_carousel_more_reviews_button_text = "More reviews";
    s.featured_carousel_view_product_button_text = "View product";
    /* Preview badge */
    s.badge_no_review_text = "Be the first to leave a review"; /* décision d'Antonio du 27/09 : invitation, plus de note de la boutique */
    s.badge_n_reviews_text = " \u00b7 Product rated {{ average_rating }}/5 from {{ n }} reviews";
    /* Testimonials / cards */
    s.testimonials_carousel_title = "What our customers say";
    s.cards_carousel_title        = "What our customers say";
    /* Floating tab */
    s.floating_tab_title = "Let our customers speak for us";
  }

  /* Run immediately if jdgmSettings already exists */
  if (window.jdgmSettings) {
    applyEN();
  } else {
    /* Wait until jdgmSettings is set (script executes before DOM ready) */
    Object.defineProperty(window, "jdgmSettings", {
      configurable: true,
      set: function (val) {
        Object.defineProperty(window, "jdgmSettings", {
          configurable: true,
          writable: true,
          value: val
        });
        applyEN();
      }
    });
  }
})();

/* ========================================
   Judge.me - French locale fix
   Corriger le texte par defaut pour les produits sans avis
   + forcer les etoiles a 4.5/5
   ======================================== */
(function () {
  "use strict";
  var locale = (window.Shopify && window.Shopify.locale) || "";
  if (locale === "en") return; /* EN deja gere au-dessus */

  function applyFR() {
    var s = window.jdgmSettings;
    if (!s) return;
    /* Preview badge - produits sans avis */
    s.badge_no_review_text = ({ de: "Geben Sie die erste Bewertung ab", it: "Lascia la prima recensione" })[locale] || "Soyez le premier à donner votre avis";
    /* Preview badge - produits avec avis */
    s.badge_n_reviews_text = ({ de: " \u00b7 Produkt mit {{ average_rating }}/5 bewertet ({{ n }} Bewertungen)", it: " \u00b7 Prodotto valutato {{ average_rating }}/5 su {{ n }} recensioni" })[locale] || " \u00b7 Produit noté {{ average_rating }}/5 sur {{ n }} avis";
  }

  if (window.jdgmSettings) {
    applyFR();
  } else {
    var origDefine = Object.getOwnPropertyDescriptor(window, "jdgmSettings");
    if (!origDefine || !origDefine.set) {
      Object.defineProperty(window, "jdgmSettings", {
        configurable: true,
        set: function (val) {
          Object.defineProperty(window, "jdgmSettings", {
            configurable: true,
            writable: true,
            value: val
          });
          applyFR();
        }
      });
    } else {
      /* Property already defined (by EN block), just poll */
      var checkInterval = setInterval(function() {
        if (window.jdgmSettings) {
          clearInterval(checkInterval);
          applyFR();
        }
      }, 100);
      setTimeout(function() { clearInterval(checkInterval); }, 5000);
    }
  }

})();

/* ========================================
   Judge.me : fiches sans avis, toutes langues (décision d'Antonio du 27/09/2026)
   Plus d'étoiles forcées : le badge reste visible, sans étoiles, avec l'invitation à laisser
   le premier avis (badge_no_review_text). Les cartes produit ne sont pas touchées.
   ======================================== */
(function () {
  "use strict";
  document.addEventListener("DOMContentLoaded", function() {
    setTimeout(function() {
      document.querySelectorAll(".jdgm-prev-badge").forEach(function(badge) {
        if (badge.closest(".yv-product-card")) return;
        var rating = badge.getAttribute("data-average-rating");
        if (rating === "0.00" || rating === "0") {
          var starsContainer = badge.querySelector(".jdgm-prev-badge__stars");
          if (starsContainer) starsContainer.style.display = "none";
          badge.style.display = "";
        }
      });
    }, 1500);
  });
})();

/* ========================================
   Shared: Moon Bundle - parse, build, wire
   Parses real Cori data from <moonbundle-component bundle='...'>
   Builds UI matching Cori DOM structure
   ======================================== */
(function () {
  "use strict";

  /* --- Utility: set quantity input with native setter --- */
  function setQty(input, val) {
    var descriptor = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype, "value"
    );
    if (descriptor && descriptor.set) {
      descriptor.set.call(input, String(val));
    } else {
      input.value = String(val);
    }
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  /* --- Decode HTML entities --- */
  function decodeEntities(str) {
    return str
      .replace(/&quot;/g, '"')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&#39;/g, "'")
      .replace(/&apos;/g, "'");
  }

  /* --- Format price in euros --- */
  function fmtPrice(cents) {
    var str = (cents / 100).toFixed(2).replace(".", ",");
    /* convention francaise : le symbole suit le nombre, precede d une espace fine insecable */
    return str + "\u202f\u20ac";
  }

  /* --- Parse Moon Bundle data from raw product page HTML --- */
  function parseMoonBundle(html) {
    var bundleMatch = html.match(/bundle='([^']+)'/);
    var mainMatch = html.match(/main-product='([^']+)'/);
    if (!bundleMatch) return null;

    try {
      var bundle = JSON.parse(decodeEntities(bundleMatch[1]));
      var mainProduct = mainMatch ? JSON.parse(decodeEntities(mainMatch[1])) : null;

      var configs = bundle.configs;
      if (!configs || !configs.length || !configs[0].offers || !configs[0].offers.length) return null;

      var offers = configs[0].offers;
      var unitPrice = mainProduct && mainProduct.variants && mainProduct.variants[0]
        ? mainProduct.variants[0].price : 0;
      var imgSrc = mainProduct ? mainProduct.image : "";

      return { offers: offers, unitPrice: unitPrice, imgSrc: imgSrc };
    } catch (e) {
      console.warn("[NKOSI MB] Parse error:", e);
      return null;
    }
  }

  /* --- Build Moon Bundle UI from parsed data --- */
  function buildMoonBundleUI(data) {
    var offers = data.offers;
    var unitPrice = data.unitPrice;
    var imgSrc = data.imgSrc || "";

    /* Find default active offer: first bestSeller, else first */
    var activeIdx = 0;
    for (var i = 0; i < offers.length; i++) {
      if (offers[i].bestSeller) { activeIdx = i; break; }
    }

    /* CSS variables matching NKOSI Cori config */
    var cssVars = [
      "--moonbundle-title-color:#055B49",
      "--moonbundle-title-font-size:20px",
      "--moonbundle-title-weight:bold",
      "--moonbundle-subtitle-color:#444444",
      "--moonbundle-subtitle-font-size:12px",
      "--moonbundle-subtitle-weight:normal",
      "--moonbundle-subtitle-style:italic",
      "--moonbundle-label-text-color:#000000",
      "--moonbundle-label-text-font-size:13px",
      "--moonbundle-best-seller-text-color:#ffffff",
      "--moonbundle-best-seller-text-font-size:15px",
      "--moonbundle-best-seller-text-weight:bold",
      "--moonbundle-price-color:#055B49",
      "--moonbundle-price-font-size:20px",
      "--moonbundle-price-weight:bold",
      "--moonbundle-compare-at-price-color:#444444",
      "--moonbundle-compare-at-price-font-size:15px",
      "--moonbundle-colors-bg:#EEEEEE",
      "--moonbundle-colors-selected-bg:#FFFFFF",
      "--moonbundle-colors-border:#DEE7E3",
      "--moonbundle-colors-selected-border:#055B49",
      "--moonbundle-colors-bg-label:#e6e6e6",
      "--moonbundle-colors-best-seller:#F29E24",
      "--moonbundle-colors-border-radius:10px",
      "--moonbundle-offer-img-size:44px",
      "--moonbundle-offer-img-border-radius:16px",
      "--moonbundle-quantity-display-color:#ffffff",
      "--moonbundle-quantity-display-background-color:#055B49",
      "--moonbundle-quantity-display-border-radius:30%"
    ].join(";");

    var h = '<div class="moonbundle-box nkosi-mb-generated" style="' + cssVars + '">';
    h += '<div class="moonbundle-options-horizontal">';

    for (var j = 0; j < offers.length; j++) {
      var o = offers[j];
      var isActive = j === activeIdx;
      var qty = o.qty || 1;
      var title = o.title || (qty + " unit\u00e9" + (qty > 1 ? "s" : ""));
      var subtitle = o.subtitle || "";
      var discount = o.discountValue || 0;
      var label = o.label && o.labelValue ? o.labelValue : "";
      var bs = o.bestSeller;
      var bsVal = o.bestSellerValue || "Le plus vendu";
      var totalOrig = unitPrice * qty;
      var totalFinal = discount ? Math.round(totalOrig * (1 - discount / 100)) : totalOrig;

      h += '<div class="moonbundle-option-wrapper">';

      /* Best seller badge */
      if (bs) {
        h += '<div class="moonbundle-best-seller-box moonbundle-best-seller-box-block">';
        h += '<div class="moonbundle-best-seller-block">' + bsVal + '</div></div>';
      }

      /* Option row */
      h += '<div id="moonbundle-option" role="button" tabindex="0" class="moonbundle-option' + (isActive ? " moonbundle-option-active" : "") + '">';
      h += '<div class="moonbundle-offer-wrapper"><div class="moonbundle-option-details">';

      /* Toggle + image */
      h += '<div class="moonbundle-option-checkbox">';
      h += '<div class="moonbundle-bullet moonbundle-bullet-toggle' + (isActive ? " checked" : "") + '">';
      h += '<div class="moonbundle-bullet-toggle-track"></div><div class="moonbundle-bullet-toggle-thumb"></div></div>';
      h += '<div style="position:relative;">';
      if (imgSrc) h += '<img class="moonbundle-offer-img" src="' + imgSrc + '">';
      h += '<div class="moonbundle-option-quantity moonbundle-option-quantity-bottom-left">x' + qty + '</div>';
      h += '</div></div>';

      /* Title + label */
      h += '<div class="moonbundle-option-col">';
      h += '<div class="moonbundle-option-col-inner" style="flex-direction:row;">';
      h += '<div class="moonbundle-option-title">' + title;
      if (isActive && qty > 1) h += ' <span class="moonbundle-quantity-multiplier">(x1)</span>';
      h += '</div>';
      if (label) h += '<div class="moonbundle-label-inside">' + label + '</div>';
      h += '</div>';

      /* Quantity selector for active multi-qty offers */
      if (isActive && qty > 1) {
        h += '<div class="moonbundle-quantity-preview-selector">';
        h += '<button type="button" class="moonbundle-quantity-preview-btn moonbundle-quantity-preview-btn-decrease" disabled>-</button>';
        h += '<input type="number" class="moonbundle-quantity-preview-input" min="1" max="99" value="1">';
        h += '<button type="button" class="moonbundle-quantity-preview-btn moonbundle-quantity-preview-btn-increase">+</button>';
        h += '</div>';
      }

      h += '<div class="moonbundle-option-subtitle">' + subtitle + '</div></div>';

      /* Price */
      h += '<div class="moonbundle-option-price">';
      h += '<div class="moonbundle-option-single-price"><span class="trans-money">' + fmtPrice(totalFinal) + '</span></div>';
      if (discount) {
        h += '<div class="moonbundle-option-old-price"><span class="trans-money">' + fmtPrice(totalOrig) + '</span></div>';
      }
      h += '</div>';

      h += '</div></div></div></div>';
    }

    h += '</div></div>';

    var tmp = document.createElement("div");
    tmp.innerHTML = h;
    return tmp.firstChild;
  }

  /* --- Wire up Moon Bundle clone interactions --- */
  function initMoonBundleClone(container, productDetail) {
    var options = container.querySelectorAll("[id=moonbundle-option]");
    var quantityInput =
      productDetail.querySelector(".quantity-input") ||
      productDetail.querySelector("input[name='quantity']") ||
      productDetail.querySelector("input.qty");

    options.forEach(function (option) {
      option.style.cursor = "pointer";
      option.addEventListener("click", function () {
        options.forEach(function (o) {
          o.classList.remove("moonbundle-option-active");
          var tog = o.querySelector(".moonbundle-bullet-toggle");
          if (tog) tog.classList.remove("checked");
        });
        option.classList.add("moonbundle-option-active");
        var tog = option.querySelector(".moonbundle-bullet-toggle");
        if (tog) tog.classList.add("checked");

        if (quantityInput) {
          var qtyBadge = option.querySelector(".moonbundle-option-quantity");
          var multiplierInput = option.querySelector(".moonbundle-quantity-preview-input");
          var baseQty = qtyBadge ? parseInt(qtyBadge.textContent.replace("x", ""), 10) : 1;
          var multiplier = multiplierInput ? (parseInt(multiplierInput.value, 10) || 1) : 1;
          var finalQty = (isNaN(baseQty) || baseQty < 1) ? 1 : baseQty * multiplier;
          setQty(quantityInput, finalQty);
        }
      });
    });

    var activeOption = container.querySelector("[id=moonbundle-option].moonbundle-option-active");
    if (activeOption && quantityInput) {
      var qtyBadge = activeOption.querySelector(".moonbundle-option-quantity");
      if (qtyBadge) {
        var initQty = parseInt(qtyBadge.textContent.replace("x", ""), 10);
        if (!isNaN(initQty) && initQty > 0) setQty(quantityInput, initQty);
      }
    }

    container.querySelectorAll(".moonbundle-quantity-preview-btn").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.stopPropagation();
        var input = btn.parentElement.querySelector(".moonbundle-quantity-preview-input");
        if (!input) return;
        var val = parseInt(input.value, 10) || 1;
        if (btn.classList.contains("moonbundle-quantity-preview-btn-increase")) {
          val++;
        } else if (val > 1) {
          val--;
        }
        input.value = val;

        var wrapper = btn.closest("[id=moonbundle-option]");
        if (wrapper && quantityInput) {
          var multiplier = wrapper.querySelector(".moonbundle-quantity-multiplier");
          if (multiplier) multiplier.textContent = "(x" + val + ")";
          var qtyBadge = wrapper.querySelector(".moonbundle-option-quantity");
          var baseQty = qtyBadge ? parseInt(qtyBadge.textContent.replace("x", ""), 10) : 1;
          setQty(quantityInput, baseQty * val);
        }

        var decBtn = btn.parentElement.querySelector(".moonbundle-quantity-preview-btn-decrease");
        if (decBtn) decBtn.disabled = val <= 1;
      });
    });
  }

  /* Export all to window */
  window._nkosiMBClone = initMoonBundleClone;
  window._nkosiParseMB = parseMoonBundle;
  window._nkosiBuildMB = buildMoonBundleUI;
})();


/* --- Moon Bundle in Featured Product Section (Homepage) - real Cori data --- */
(function () {
  "use strict";

  function injectMoonBundleInFeaturedProduct() {
    var isHome = window.Shopify && window.Shopify.template === "index";
    if (!isHome) {
      var path = window.location.pathname;
      isHome = path === "/" || /^\/(fr|en|de|es|it|nl|pt-pt)?\/?$/i.test(path);
    }
    if (!isHome) return;

    var featuredSection = document.querySelector(".featured-product-section");
    if (!featuredSection) return;

    /* Skip if we already injected */
    if (featuredSection.querySelector(".nkosi-mb-generated")) return;

    var productWrapper = featuredSection.querySelector("[data-url]");
    if (!productWrapper) return;
    var productUrl = productWrapper.getAttribute("data-url");
    if (!productUrl) return;

    var productDetail = featuredSection.querySelector(".yv-feature-product-detail");
    if (!productDetail) return;

    fetch(productUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        /* Re-check after async fetch */
        if (featuredSection.querySelector(".nkosi-mb-generated")) return;

        var data = window._nkosiParseMB ? window._nkosiParseMB(html) : null;
        if (!data) return;

        /* Hide the Liquid-rendered hardcoded bundle if present */
        var oldBundle = featuredSection.querySelector(".nkosi-volume-bundle");

        var mbEl = window._nkosiBuildMB(data);
        var container = document.createElement("div");
        container.className = "nkosi-featured-moonbundle";
        container.style.cssText = "margin-top:16px;width:100%";
        container.appendChild(mbEl);

        if (oldBundle) {
          /* Replace Liquid bundle with real-data bundle in the same position */
          oldBundle.parentNode.insertBefore(container, oldBundle);
          oldBundle.style.display = "none";
        } else {
          var productForm = productDetail.querySelector("product-form");
          if (productForm) {
            productForm.parentNode.insertBefore(container, productForm.nextSibling);
          } else {
            productDetail.appendChild(container);
          }
        }

        if (window._nkosiMBClone) window._nkosiMBClone(container, productDetail);
      })
      .catch(function (err) {
        console.warn("[NKOSI] Featured MB fetch failed:", err);
      });
  }

  /* Wait 4s to give Cori app time to render natively first */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      setTimeout(injectMoonBundleInFeaturedProduct, 4000);
    });
  } else {
    setTimeout(injectMoonBundleInFeaturedProduct, 4000);
  }
})();


/* --- Sélecteur de langue - header: JS click, footer: JS click --- */
(function () {
  "use strict";

  function initHeaderLang() {
    var wrapper = document.querySelector(".nkosi-header-lang");
    if (!wrapper || wrapper.getAttribute("data-nkosi-lang-init")) return;
    wrapper.setAttribute("data-nkosi-lang-init", "1");

    var trigger = wrapper.querySelector(".detail-box.lang-dropdown");
    if (!trigger) return;

    /* Build a portal dropdown outside theme DOM to avoid its CSS constraints */
    var origPanel = trigger.querySelector(".lang-dropdown-expand.country-dropdown-expand");
    var portal = document.createElement("div");
    portal.className = "nkosi-lang-portal";
    /* Marché Collage S3 : l'habillage vient de nkosi-marche-collage.css (section 27), ici la seule position */
    portal.style.cssText = "display:none;position:absolute;z-index:1000;top:calc(100% + 6px);right:0;left:auto;";

    /* Clone the language list into the portal */
    if (origPanel) {
      var ul = origPanel.querySelector("ul");
      if (ul) portal.appendChild(ul.cloneNode(true));
      /* Remove original dropdown from DOM entirely - CSS can override display:none */
      origPanel.parentNode.removeChild(origPanel);
      /* Replace portal buttons with <a> links for reliable locale switch */
      portal.querySelectorAll("button[name='locale_code']").forEach(function (btn) {
        var lang = btn.value;
        var a = document.createElement("a");
        /* Build localized URL */
        var path = window.location.pathname.replace(/^\/(fr|en|de|es|it|nl|pt-pt)(\/|$)/i, "/");
        a.href = lang === "fr" ? (path || "/") + window.location.search : "/" + lang + (path || "/") + window.location.search;
        /* code et nom de la langue (spans du gabarit), sans style en ligne */
        a.innerHTML = btn.innerHTML;
        a.className = btn.className + " nk-langue-lien";
        a.setAttribute("hreflang", lang);
        if (btn.getAttribute("aria-current")) a.setAttribute("aria-current", "true");
        btn.parentNode.replaceChild(a, btn);
      });
    }

    /* Attach portal to country-select-box for positioning */
    var selectBox = wrapper.querySelector(".country-select-box");
    if (selectBox) {
      selectBox.style.position = "relative";
      selectBox.appendChild(portal);
    }

    var isOpen = false;

    /* S3 (27/09) : le déclencheur se comporte en bouton (clavier : Entrée ou Espace ; état annoncé) */
    trigger.setAttribute("role", "button");
    trigger.setAttribute("aria-haspopup", "true");
    trigger.setAttribute("aria-expanded", "false");

    function open() {
      wrapper.classList.add("nkosi-lang-open");
      portal.style.display = "block";
      trigger.setAttribute("aria-expanded", "true");
      isOpen = true;
    }

    function close() {
      wrapper.classList.remove("nkosi-lang-open");
      portal.style.display = "none";
      trigger.setAttribute("aria-expanded", "false");
      isOpen = false;
    }

    trigger.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); isOpen ? close() : open(); }
      else if (e.key === "Escape") { close(); }
    });

    /* Capture phase - fires before theme's stopPropagation handlers */
    wrapper.addEventListener("click", function (e) {
      if (trigger === e.target || trigger.contains(e.target)) {
        if (portal.contains(e.target)) return; /* Don't toggle if clicking inside portal */
        e.stopPropagation();
        isOpen ? close() : open();
      }
    }, true);

    /* Mousedown outside → close */
    document.addEventListener("mousedown", function (e) {
      if (!wrapper.contains(e.target) && !portal.contains(e.target)) {
        close();
      }
    });
  }

  /* Footer: portal dropdown (same mechanism as header) */
  function initFooterLang() {
    var footer = document.querySelector(".footer-dropdown");
    if (!footer || footer.getAttribute("data-nkosi-lang-init")) return;
    footer.setAttribute("data-nkosi-lang-init", "1");

    var trigger = footer.querySelector(".detail-box.lang-dropdown");
    if (!trigger) return;

    /* Build a portal dropdown outside trigger to avoid e.preventDefault conflicts */
    var origPanel = trigger.querySelector(".lang-dropdown-expand.country-dropdown-expand");
    var portal = document.createElement("div");
    portal.className = "nkosi-lang-portal";
    portal.style.cssText = "display:none;position:absolute;z-index:1000;bottom:calc(100% + 6px);left:0;right:auto;";

    /* Clone the language list into the portal */
    if (origPanel) {
      var ul = origPanel.querySelector("ul");
      if (ul) portal.appendChild(ul.cloneNode(true));
      /* Remove original dropdown from DOM entirely - CSS can override display:none */
      origPanel.parentNode.removeChild(origPanel);
      /* Replace portal buttons with <a> links for reliable locale switch */
      portal.querySelectorAll("button[name='locale_code']").forEach(function (btn) {
        var lang = btn.value;
        var a = document.createElement("a");
        var path = window.location.pathname.replace(/^\/(fr|en|de|es|it|nl|pt-pt)(\/|$)/i, "/");
        a.href = lang === "fr" ? (path || "/") + window.location.search : "/" + lang + (path || "/") + window.location.search;
        a.innerHTML = btn.innerHTML;
        a.className = btn.className + " nk-langue-lien";
        a.setAttribute("hreflang", lang);
        if (btn.getAttribute("aria-current")) a.setAttribute("aria-current", "true");
        btn.parentNode.replaceChild(a, btn);
      });
    }

    /* Attach portal to country-select-box for positioning */
    var selectBox = footer.querySelector(".country-select-box");
    if (selectBox) {
      selectBox.style.position = "relative";
      selectBox.appendChild(portal);
    }

    var isOpen = false;
    trigger.setAttribute("role", "button");
    trigger.setAttribute("aria-haspopup", "true");
    trigger.setAttribute("aria-expanded", "false");
    function open() { footer.classList.add("nkosi-lang-open"); portal.style.display = "block"; trigger.setAttribute("aria-expanded", "true"); isOpen = true; }
    function close() { footer.classList.remove("nkosi-lang-open"); portal.style.display = "none"; trigger.setAttribute("aria-expanded", "false"); isOpen = false; }
    trigger.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); isOpen ? close() : open(); }
      else if (e.key === "Escape") { close(); }
    });

    footer.addEventListener("click", function (e) {
      if (trigger === e.target || trigger.contains(e.target)) {
        if (portal.contains(e.target)) return; /* Don't toggle if clicking inside portal */
        e.stopPropagation();
        isOpen ? close() : open();
      }
    }, true);

    document.addEventListener("mousedown", function (e) {
      if (!footer.contains(e.target) && !portal.contains(e.target)) { close(); }
    });
  }

  function initAll() {
    initHeaderLang();
    initFooterLang();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { setTimeout(initAll, 300); });
  } else {
    setTimeout(initAll, 300);
  }
})();


/* --- Shared: Product Slider Arrow Navigation --- */
(function () {
  "use strict";
  window._nkosiSliderArrows = function (wrap) {
    var track = wrap.querySelector(".nkosi-pv-grid, .nkosi-bs-track");
    if (!track) return;

    var prev = document.createElement("button");
    prev.type = "button";
    prev.className = "nkosi-slider-arrow nkosi-slider-arrow--prev";
    prev.setAttribute("aria-label", "Précédent");
    prev.innerHTML = '<svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"></polyline></svg>';

    var next = document.createElement("button");
    next.type = "button";
    next.className = "nkosi-slider-arrow nkosi-slider-arrow--next";
    next.setAttribute("aria-label", "Suivant");
    next.innerHTML = '<svg viewBox="0 0 24 24"><polyline points="9 6 15 12 9 18"></polyline></svg>';

    wrap.appendChild(prev);
    wrap.appendChild(next);

    function step() { return track.offsetWidth * 0.75; }
    prev.addEventListener("click", function () {
      track.scrollBy({ left: -step(), behavior: "smooth" });
    });
    next.addEventListener("click", function () {
      track.scrollBy({ left: step(), behavior: "smooth" });
    });
  };
})();


/* --- Produits Vedettes - horizontal slider + shuffle --- */
(function () {
  "use strict";

  function shuffleArr(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = arr[i]; arr[i] = arr[j]; arr[j] = t;
    }
    return arr;
  }

  function initPVSection() {
    var grid = document.querySelector("[data-nkosi-pv-grid]");
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll(".nkosi-pv-card"));
    if (!cards.length) return;

    /* Shuffle and show ALL cards in slider */
    shuffleArr(cards);
    cards.forEach(function (c) {
      c.classList.remove("nkosi-pv-hidden");
      grid.appendChild(c);
    });

    /* Wrap grid in slider wrapper for arrow positioning */
    var wrap = document.createElement("div");
    wrap.className = "nkosi-slider-wrap";
    grid.parentNode.insertBefore(wrap, grid);
    wrap.appendChild(grid);

    /* Add arrow buttons */
    if (window._nkosiSliderArrows) window._nkosiSliderArrows(wrap);

    /* Build heading controls: shuffle only */
    var heading = document.querySelector(".nkosi-pv-heading");
    if (heading) {
      var shuffleBtn = heading.querySelector("[data-nkosi-pv-shuffle]");
      var controls = document.createElement("div");
      controls.className = "nkosi-slider-controls";
      if (shuffleBtn) controls.appendChild(shuffleBtn);

      heading.appendChild(controls);

      /* Convert shuffle button to link → all products collection */
      if (shuffleBtn) {
        shuffleBtn.addEventListener("click", function () {
          window.location.href = "/collections/all";
        });
        shuffleBtn.style.cursor = "pointer";
      }

      /* Translate PV section title based on locale (Marché Collage S2, 27/09/2026 : sans émoji) */
      var _pvLocale = (window.Shopify && window.Shopify.locale) || "fr";
      var _pvT = {
        "fr":    { title: "Produits vedettes" },
        "en":    { title: "Featured products" },
        "de":    { title: "Ausgewählte Produkte" },
        "es":    { title: "Productos destacados" },
        "it":    { title: "Prodotti in evidenza" },
        "nl":    { title: "Aanbevolen producten" },
        "pt-pt": { title: "Produtos em destaque" }
      };
      var _pvLang = _pvT[_pvLocale] || _pvT["en"];
      var pvTitleEl = heading.querySelector(".nkosi-pv-title");
      if (pvTitleEl) pvTitleEl.textContent = _pvLang.title;
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPVSection);
  } else {
    initPVSection();
  }
})();




/* --- Featured Product - fix quantity input for bundles --- */
(function () {
  "use strict";

  function fixFeaturedQty() {
    var section = document.getElementById(
      "shopify-section-template--25519365521742__featured_product_qdd9BV"
    );
    if (!section) return;

    var form = section.querySelector("form[action*='/cart/add']");
    if (!form) return;

    /* Inject hidden quantity input if missing */
    var qi = form.querySelector("input[name='quantity']");
    if (!qi) {
      qi = document.createElement("input");
      qi.type = "hidden";
      qi.name = "quantity";
      qi.value = "1";
      form.appendChild(qi);
    }

    /* Set initial qty from the active bundle option */
    var activeOpt = section.querySelector(".nkosi-bundle-opt.nkosi-bundle-active");
    if (activeOpt) {
      var initQty = parseInt(activeOpt.getAttribute("data-qty"), 10);
      if (initQty > 0) qi.value = String(initQty);
    }

    /* Wire ALL bundle options to update qty */
    section.querySelectorAll(".nkosi-bundle-opt").forEach(function (o) {
      o.addEventListener("click", function () {
        var qty = parseInt(o.getAttribute("data-qty"), 10);
        if (qty > 0) qi.value = String(qty);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fixFeaturedQty);
  } else {
    fixFeaturedQty();
  }
})();


/* --- Cart - Quick Add on similar products --- */
(function () {
  "use strict";

  function addCartQuickActions() {
    var sidebar = document.querySelector(
      ".upsell-product-slider, .cart-upsell, .yv-upsell-slider, " +
      "[data-upsell-products], .cart-recommendations"
    );
    if (!sidebar) return;

    var cards = sidebar.querySelectorAll(
      ".yv-product-card, .product-grid-item, article, .upsell-item"
    );
    if (!cards.length) return;

    cards.forEach(function (card) {
      if (card.querySelector(".nkosi-quick-add-btn")) return;

      var link = card.querySelector("a[href*='/products/']");
      if (!link) return;
      var productUrl = link.getAttribute("href").split("?")[0];

      /* Quick Add button overlay */
      var btnWrap = document.createElement("div");
      btnWrap.className = "nkosi-cart-quick-actions";

      var addBtn = document.createElement("button");
      addBtn.type = "button";
      addBtn.className = "nkosi-quick-add-btn";
      addBtn.textContent = "＋ Ajouter";
      addBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        addBtn.textContent = "...";
        addBtn.disabled = true;

        fetch(productUrl + ".js")
          .then(function (r) { return r.json(); })
          .then(function (product) {
            var variantId = product.variants[0].id;
            return fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
            });
          })
          .then(function () {
            addBtn.textContent = "✓ Ajouté";
            setTimeout(function () {
              addBtn.textContent = "＋ Ajouter";
              addBtn.disabled = false;
              /* Refresh cart */
              var evt = new CustomEvent("cart:refresh");
              document.dispatchEvent(evt);
              /* Fallback: reload cart drawer */
              if (window.location.pathname === "/cart") {
                window.location.reload();
              } else {
                var cartTrigger = document.querySelector(
                  "[data-cart-trigger], .cart-icon-link, .header__icon--cart"
                );
                if (cartTrigger) cartTrigger.click();
              }
            }, 800);
          })
          .catch(function () {
            addBtn.textContent = "＋ Ajouter";
            addBtn.disabled = false;
          });
      });

      btnWrap.appendChild(addBtn);
      card.style.position = "relative";
      card.appendChild(btnWrap);
    });
  }

  /* Re-run when cart drawer opens or changes */
  function watchCart() {
    addCartQuickActions();

    /* 2026-09-21 : un passage au plus toutes les 200 ms (il y en avait un à chaque mutation de la page,
       sur toutes les pages). Les boutons apparaissent au plus 200 ms après le rendu des suggestions. */
    var nkQuickT = null;
    new MutationObserver(function () {
      if (nkQuickT) { return; }
      nkQuickT = setTimeout(function () { nkQuickT = null; addCartQuickActions(); }, 200);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      setTimeout(watchCart, 1500);
    });
  } else {
    setTimeout(watchCart, 1500);
  }
})();


/* --- Klaviyo Form Translation (form XjHJJx) --- */
(function () {
  "use strict";

  var T = {
    fr:      { h: "Rejoignez nous",   d: "Rejoignez notre communauté et recevez votre code de réduction de 10% en vous inscrivant à notre canal d'information E-mail", p: "Votre adresse e-mail",   b: "REJOINDRE", pref: "Préférence de communication", rf: "fr" },
    en:      { h: "Join us",          d: "Join our community and get your 10% discount code by subscribing to our Email channel",   p: "Your email address",     b: "JOIN",       pref: "Communication preference", rf: "en" },
    de:      { h: "Tritt uns bei",    d: "Tritt unserer Community bei und erhalte deinen 10% Rabattcode, indem du dich für unseren E-Mail-Kanal anmeldest",  p: "Deine E-Mail-Adresse",   b: "BEITRETEN",  pref: "Kommunikationspräferenz", rf: "en" },
    es:      { h: "Únete a nosotros", d: "Únete a nuestra comunidad y recibe tu código de descuento del 10% suscribiéndote a nuestro canal de Email",   p: "Tu correo electrónico",  b: "UNIRSE",     pref: "Preferencia de comunicación", rf: "en" },
    it:      { h: "Unisciti a noi",   d: "Unisciti alla nostra comunità e ricevi il tuo codice sconto del 10% iscrivendoti al nostro canale Email",  p: "Il tuo indirizzo email", b: "ISCRIVITI",  pref: "Preferenza di comunicazione", rf: "en" },
    nl:      { h: "Word lid",         d: "Word lid van onze community en ontvang je 10% kortingscode door je aan te melden voor ons E-mailkanaal",  p: "Uw e-mailadres",         b: "DEELNEMEN",  pref: "Communicatievoorkeur", rf: "en" },
    "pt-pt": { h: "Junte-se a nós",   d: "Junte-se à nossa comunidade e receba o seu código de desconto de 10% ao inscrever-se no nosso canal de Email",  p: "O seu e-mail",            b: "JUNTAR",     pref: "Preferência de comunicação", rf: "en" }
  };

  function getLocale() {
    var loc = (window.Shopify && window.Shopify.locale) ||
              document.documentElement.lang || "fr";
    return loc.toLowerCase();
  }

  function getTrans(locale) {
    return T[locale] || T[locale.split("-")[0]] || T.fr;
  }

  function applyKlaviyoTranslation(form) {
    var t = getTrans(getLocale());

    // Heading
    var h = form.querySelector("h1 span, h2 span, h3 span, h4 span");
    if (!h) h = form.querySelector("h1, h2, h3, h4");
    if (h) h.textContent = t.h;

    // Description
    var p = form.querySelector("p span");
    if (!p) p = form.querySelector("p");
    if (p) p.textContent = t.d;

    // Email placeholder
    var emailInput = form.querySelector("input[type='email']");
    if (emailInput) emailInput.placeholder = t.p;

    // Submit button (skip icon-only buttons)
    form.querySelectorAll("button").forEach(function (btn) {
      if (btn.textContent.trim().length > 1 && !btn.querySelector("svg")) {
        btn.textContent = t.b;
      }
    });

    // Language Preference radio - auto-select based on locale
    form.querySelectorAll("input[type='radio']").forEach(function (radio) {
      var lbl = form.querySelector('label[for="' + radio.id + '"]');
      var txt = lbl
        ? lbl.textContent.trim()
        : ((radio.closest("label") || radio.parentElement || {}).textContent || "").trim();

      var shouldSelect =
        (t.rf === "fr" && /fran[çc]ais/i.test(txt)) ||
        (t.rf === "en" && /english/i.test(txt));

      if (shouldSelect && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }

  function findKlaviyoForm() {
    return document.querySelector(
      '[data-form-id="XjHJJx"], .klaviyo-form-XjHJJx, #klaviyo-form-XjHJJx, [id*="XjHJJx"]'
    );
  }

  /* Build custom newsletter form when Klaviyo targeting blocks it on non-French pages */
  function buildCustomNewsletter() {
    /* Check if Klaviyo already rendered a visible form */
    var existingForm = findKlaviyoForm();
    if (existingForm) {
      var rect = existingForm.getBoundingClientRect();
      if (rect.height > 50) return false; /* Klaviyo rendered fine */
    }

    /* Find the custom_liquid section that should host the newsletter */
    var section = document.querySelector("[id*='custom_liquid_hQxTTP']");
    if (!section) return false;
    if (section.querySelector(".nkosi-newsletter-custom")) return true;

    var t = getTrans(getLocale());

    var wrap = document.createElement("div");
    wrap.className = "nkosi-newsletter-custom";
    wrap.innerHTML =
      '<div class="nkosi-newsletter-inner">' +
        '<h3 class="nkosi-newsletter-title">' + t.h + '</h3>' +
        '<p class="nkosi-newsletter-desc">' + t.d + '</p>' +
        '<div class="nkosi-newsletter-email-row" style="padding:0 0 10px 0;">' +
          '<input type="email" class="nkosi-newsletter-email" placeholder="' + t.p + '" required />' +
        '</div>' +
        '<div class="nkosi-newsletter-row">' +
          '<div class="nkosi-newsletter-prefs">' +
            '<span class="nkosi-newsletter-prefs-label">' + (t.pref || "Communication preference") + '</span>' +
            '<label class="nkosi-newsletter-radio-label"><input type="radio" name="nkosi_lang_pref" value="fr"' + (t.rf === "fr" ? ' checked' : '') + '> Fran\u00e7ais</label>' +
            '<label class="nkosi-newsletter-radio-label"><input type="radio" name="nkosi_lang_pref" value="en"' + (t.rf === "en" ? ' checked' : '') + '> English</label>' +
          '</div>' +
          '<button type="button" class="nkosi-newsletter-btn nkosi-newsletter-submit">' + t.b + '</button>' +
        '</div>' +
        '<div class="nkosi-newsletter-msg" style="display:none;margin-top:8px;font-size:14px;"></div>' +
      '</div>';

    section.innerHTML = '';
    section.style.cssText = 'padding:0 !important;margin:0 !important;';
    section.appendChild(wrap);

    /* Handle form submission via Klaviyo client-side API */
    var emailInput = wrap.querySelector(".nkosi-newsletter-email");
    var msgDiv = wrap.querySelector(".nkosi-newsletter-msg");
    var btn = wrap.querySelector(".nkosi-newsletter-submit");
    var locale = getLocale();
    var successMsgs = {
      fr: "Merci \u2014 v\u00e9rifiez votre bo\u00eete mail !",
      en: "Thanks \u2014 check your inbox!",
      de: "Danke \u2014 pr\u00fcfen Sie Ihren Posteingang!",
      es: "\u00a1Gracias! Revisa tu bandeja de entrada.",
      it: "Grazie \u2014 controlla la tua casella!",
      nl: "Bedankt \u2014 check je inbox!",
      "pt-pt": "Obrigado \u2014 verifique a sua caixa de entrada!"
    };
    var errorMsgs = {
      fr: "Adresse e-mail invalide.",
      en: "Invalid email address.",
      de: "Ung\u00fcltige E-Mail-Adresse.",
      es: "Direcci\u00f3n de correo inv\u00e1lida.",
      it: "Indirizzo email non valido.",
      nl: "Ongeldig e-mailadres.",
      "pt-pt": "Endere\u00e7o de email inv\u00e1lido."
    };
    var successMsg = successMsgs[locale] || successMsgs[locale.split("-")[0]] || successMsgs.en;
    var errorMsg = errorMsgs[locale] || errorMsgs[locale.split("-")[0]] || errorMsgs.en;

    btn.addEventListener("click", function () {
      var email = emailInput.value.trim();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        msgDiv.style.display = "block";
        msgDiv.style.color = "#c0392b";
        msgDiv.textContent = errorMsg;
        return;
      }
      btn.disabled = true;
      btn.textContent = "...";

      var langPref = wrap.querySelector("input[name='nkosi_lang_pref']:checked");
      var prefValue = langPref ? langPref.value : (t.rf || "en");

      /* Identify in Klaviyo + track newsletter signup */
      var _learnq = window._learnq || [];
      _learnq.push(["identify", { "$email": email, "$consent": ["email"], "Language Preference": prefValue === "fr" ? "Fran\u00e7ais" : "English" }]);
      _learnq.push(["track", "Signed Up for Newsletter", { source: "website_footer", locale: locale, language_preference: prefValue }]);

      msgDiv.style.display = "block";
      msgDiv.style.color = "#055B49";
      msgDiv.textContent = successMsg;
      emailInput.value = "";
      btn.textContent = "\u2713";
      setTimeout(function () { btn.textContent = t.b; btn.disabled = false; }, 4000);
    });

    return true;
  }

  function startKlaviyoTranslation() {
    var locale = getLocale();

    /* French: Klaviyo renders natively, no action needed */
    if (locale === "fr") return;

    /* Non-French: wait for Klaviyo to attempt rendering, then check */
    setTimeout(function () {
      var built = buildCustomNewsletter();
      if (!built) {
        /* Klaviyo rendered - translate it */
        var form = findKlaviyoForm();
        if (form) {
          applyKlaviyoTranslation(form);
          setTimeout(function () { applyKlaviyoTranslation(form); }, 1500);
        }
      }
    }, 3000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startKlaviyoTranslation);
  } else {
    startKlaviyoTranslation();
  }
})();

/* =============================================
   NKOSI Cart Drawer Enhancements v2
   - Reassurance badges before checkout button
   - Review social proof badge
   - Panier vide : module « Tiroir du panier vide » juste après (27/09/2026)
   Date: 2026-04-10
   ============================================= */
(function() {
  'use strict';

  var REASSURANCE_HTML = '<div class="nkosi-cart-reassurance">' +
    '<div class="nkosi-reassurance-item">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="#055B49" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M9 12l2 2 4-4" stroke="#055B49" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '<span>Paiement s\u00e9curis\u00e9</span>' +
    '</div>' +
    '<div class="nkosi-reassurance-item">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none"><rect x="1" y="3" width="15" height="13" rx="2" stroke="#055B49" stroke-width="1.5"/><path d="M16 8h4l3 4v5h-3M1 16h1M6 20a2 2 0 100-4 2 2 0 000 4zM18 20a2 2 0 100-4 2 2 0 000 4z" stroke="#055B49" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '<span>Livraison rapide</span>' +
    '</div>' +
    '<div class="nkosi-reassurance-item">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M23 6l-13.5 13.5L3 13" stroke="#055B49" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '<span>Satisfait ou rembours\u00e9</span>' +
    '</div>' +
  '</div>';

  /* Marché Collage S3 (27/09/2026) : plus de chiffre écrit en dur (« 4,5/5, +2000 clients » était faux).
     La note est celle du pied de page, lue en direct dans Judge.me par Liquid ; sans elle, pas de badge. */
  function badgeAvis() {
    var source = document.querySelector('.nk-mc-pied-avis');
    var texte = source ? source.textContent.replace(/[\u2605\s]+/g, ' ').trim() : '';
    if (!texte) return null;
    var badge = document.createElement('div');
    badge.className = 'nkosi-cart-reviews-badge';
    badge.innerHTML = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" style="vertical-align:-2px"><path d="M8 1.333l2.06 4.174 4.607.67-3.334 3.25.787 4.586L8 11.847l-4.12 2.166.787-4.586L1.333 6.177l4.607-.67L8 1.333z" fill="#F29E24"/></svg><span></span>';
    badge.querySelector('span').textContent = texte;
    return badge;
  }

  function injectReassurance() {
    var checkoutBtn = document.querySelector('.cart-btn-container');
    if (!checkoutBtn) return;
    if (checkoutBtn.parentElement.querySelector('.nkosi-cart-reassurance, [data-nk-reassurance]')) return;
    checkoutBtn.insertAdjacentHTML('beforebegin', REASSURANCE_HTML);
    var badge = badgeAvis();
    if (badge) checkoutBtn.parentElement.insertBefore(badge, checkoutBtn);
  }

  function tryInject() {
    injectReassurance();
  }

  // 1. MutationObserver on drawer body
  var drawerBody = document.querySelector('[data-drawer-body]');
  if (drawerBody) {
    var nkDrawerTimer = null;
    new MutationObserver(function() {
      if (nkDrawerTimer) { clearTimeout(nkDrawerTimer); }
      nkDrawerTimer = setTimeout(tryInject, 400);
    }).observe(drawerBody, { childList: true, subtree: true });
  }

  // 2. Listen for drawer open class on body
  new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      if (m.attributeName === 'class' && document.body.classList.contains('yv_side_Drawer_open')) {
        setTimeout(tryInject, 600);
        setTimeout(tryInject, 1500);
      }
    });
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  // 3. Click listeners on ALL cart triggers
  document.addEventListener('click', function(e) {
    if (e.target.closest('.openCartDrawer, .cart-icon, [data-cart-icon], .cart-link, .Sd_addProduct, .add_to_cart')) {
      setTimeout(tryInject, 800);
      setTimeout(tryInject, 1800);
      setTimeout(tryInject, 3000);
    }
  });

  // 4. Fallback on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(tryInject, 1500); });
  } else {
    setTimeout(tryInject, 1500);
  }
})();

/* =============================================
   Marché Collage : tiroir du panier vide (Moon Bundles)
   Demande d'Antonio du 27/09/2026 : un panier vide ne doit pas perdre le client.
   Quand le tiroir s'ouvre vide, on copie dans .moonbundle-cart-empty le modèle rendu par le serveur
   (snippets/nkosi-mc-panier-vide.liquid : noms, prix et adresses dans la langue de la page) : la phrase
   de la marque, puis une rangée de produits à ajouter en un clic (meilleure vente, promo, kit, en
   alternance) et une dernière carte « Faire mon marché ».
   Textes : langue de document.documentElement.lang (fr, en, de, it ; le français sinon).
   Ajout : POST /cart/add.js?moonbundle_ignore=true (sans la fenêtre « Ajouté à votre panier » des cadeaux
   progressifs, qui fermerait le tiroir), puis rafraîchissement du tiroir, des cadeaux et du compteur :
   l'état vide disparaît avec le bloc, la frise des paliers prend le relais.
   Aucun décalage : la copie se fait dans le rappel de l'observateur, avant le premier affichage du tiroir
   ouvert ; photos en carré réservé, noms sur deux lignes réservées (nkosi-marche-collage.css, section 38).
   Sans modèle dans la page (balise render retirée de layout/theme.liquid), rien ne change : le texte de
   Moon Bundles reste. Remplace l'ancien « Best sellers when cart is empty » (tiroir du thème .emptySideCart,
   absent depuis Moon Bundles : la fonction ne s'exécutait plus).
   ============================================= */
(function () {
  'use strict';
  var modele = document.getElementById('nk-pv-modele');
  if (!modele || !modele.content || !window.MutationObserver) return;

  var TXT = {
    fr: {
      surtitre: 'Le panier est vide.', titre: 'Le marché, lui, est plein',
      intro: 'Meilleures ventes, promos du moment et kits recettes : ajoutez-les en un clic.',
      tag_vente: 'Meilleure vente', tag_kit: 'Kit recette', tag_promo: 'Promo',
      ajouter: 'Ajouter', ajoute: 'Ajouté', erreur: 'Réessayer', choisir: 'Choisir', tout: 'Faire mon marché',
      ajouter_aria: 'Ajouter au panier : %s', choisir_aria: 'Choisir : %s',
      prec: 'Produits précédents', suiv: 'Produits suivants', liste: 'Idées pour remplir le panier',
      prix_avant: 'Prix avant remise : '
    },
    en: {
      surtitre: 'Your basket is empty.', titre: 'The market isn’t',
      intro: 'Best sellers, current deals and recipe kits: add them in one click.',
      tag_vente: 'Best seller', tag_kit: 'Recipe kit', tag_promo: 'Deal',
      ajouter: 'Add', ajoute: 'Added', erreur: 'Try again', choisir: 'Choose', tout: 'Shop the market',
      ajouter_aria: 'Add to cart: %s', choisir_aria: 'Choose: %s',
      prec: 'Previous products', suiv: 'Next products', liste: 'Ideas to fill your basket',
      prix_avant: 'Price before discount: '
    },
    de: {
      surtitre: 'Der Warenkorb ist leer.', titre: 'Der Markt ist voll',
      intro: 'Bestseller, aktuelle Angebote und Rezept-Kits: mit einem Klick in den Warenkorb.',
      tag_vente: 'Bestseller', tag_kit: 'Rezept-Kit', tag_promo: 'Angebot',
      ajouter: 'Hinzufügen', ajoute: 'Hinzugefügt', erreur: 'Erneut versuchen', choisir: 'Wählen', tout: 'Jetzt einkaufen',
      ajouter_aria: 'In den Warenkorb: %s', choisir_aria: 'Wählen: %s',
      prec: 'Vorherige Produkte', suiv: 'Weitere Produkte', liste: 'Ideen für Ihren Warenkorb',
      prix_avant: 'Preis vor Rabatt: '
    },
    it: {
      surtitre: 'Il carrello è vuoto.', titre: 'Il mercato, invece, è pieno',
      intro: 'I più venduti, le promo del momento e i kit ricetta, da aggiungere con un clic.',
      tag_vente: 'Più venduto', tag_kit: 'Kit ricetta', tag_promo: 'Promo',
      ajouter: 'Aggiungi', ajoute: 'Aggiunto', erreur: 'Riprova', choisir: 'Scegli', tout: 'Fare la spesa',
      ajouter_aria: 'Aggiungi al carrello: %s', choisir_aria: 'Scegli: %s',
      prec: 'Prodotti precedenti', suiv: 'Prodotti successivi', liste: 'Idee per riempire il carrello',
      prix_avant: 'Prezzo prima dello sconto: '
    }
  };
  var L = String(document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
  var T = TXT[L] || TXT.fr;
  var RACINE = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function t(cle) { return T[cle] != null ? T[cle] : (TXT.fr[cle] || ''); }
  function tous(racine, sel) { return Array.prototype.slice.call(racine.querySelectorAll(sel)); }
  /* remise entière, arrondie vers le bas comme les cartes du thème : jamais plus que la remise réelle */
  function remise(n) {
    n = parseInt(n, 10);
    if (!(n > 0)) return t('tag_promo');
    return '-' + n + (L === 'en' || L === 'it' ? '%' : ' %');
  }

  function construire() {
    var frag = modele.content.cloneNode(true);
    var rangee = frag.querySelector('[data-nk-pv-rangee]');
    tous(frag, '[data-nk-pv-t]').forEach(function (el) { el.textContent = t(el.getAttribute('data-nk-pv-t')); });
    tous(frag, '[data-nk-pv-tag]').forEach(function (el) {
      var type = el.getAttribute('data-nk-pv-tag');
      el.textContent = type === 'promo' ? remise(el.getAttribute('data-nk-pv-remise')) : t(type === 'kit' ? 'tag_kit' : 'tag_vente');
    });
    tous(frag, '[data-nk-pv-nom]').forEach(function (el) {
      var cle = el.hasAttribute('data-nk-pv-ajout') ? 'ajouter_aria' : 'choisir_aria';
      el.setAttribute('aria-label', t(cle).replace('%s', el.getAttribute('data-nk-pv-nom')));
    });
    tous(frag, '[data-nk-pv-nav]').forEach(function (el) {
      el.setAttribute('aria-label', t(el.getAttribute('data-nk-pv-nav') === '-1' ? 'prec' : 'suiv'));
    });
    if (rangee) {
      rangee.setAttribute('aria-label', t('liste'));
      /* alternance des sources : le premier de chaque source, puis le deuxième, etc. (tri stable) */
      var cartes = Array.prototype.slice.call(rangee.children);
      cartes.sort(function (a, b) {
        return (parseInt(a.getAttribute('data-nk-pv-rang'), 10) || 0) - (parseInt(b.getAttribute('data-nk-pv-rang'), 10) || 0);
      });
      cartes.forEach(function (li) { rangee.appendChild(li); });
      /* les trois premières photos tout de suite, les suivantes quand la rangée défile */
      tous(rangee, 'img').slice(0, 3).forEach(function (img) { img.setAttribute('loading', 'eager'); });
    }
    return frag;
  }

  function majNav(bloc) {
    var r = bloc.querySelector('[data-nk-pv-rangee]');
    if (!r) return;
    var fin = r.scrollWidth - r.clientWidth - 2;
    tous(bloc, '[data-nk-pv-nav]').forEach(function (b) {
      var off = b.getAttribute('data-nk-pv-nav') === '-1' ? r.scrollLeft <= 2 : r.scrollLeft >= fin;
      if (b.disabled !== off) b.disabled = off;
    });
  }

  /* compteur de l'en-tête, comme nkosi-atc-ajax.js (Moon Bundles ne connaît pas [data-cart-count]) */
  function majCompteur(panier) {
    tous(document, '[data-cart-count]').forEach(function (el) {
      if (panier.item_count > 0) { el.style.display = ''; el.textContent = panier.item_count < 100 ? String(panier.item_count) : ''; }
      else { el.style.display = 'none'; }
    });
  }

  /* Du vide au plein sans décalage : Moon Bundles redessine le tiroir en plusieurs temps (ligne, frise, message des
     cadeaux, note du minimum), plus de 500 ms après le clic ; ces glissements comptaient dans le CLS (0,20 mesuré sur
     mobile le 27/09). Le corps et le pied du tiroir quittent l'affichage le temps du redessin (une roue tourne à la
     place, classe nk-pv-transition sur <html>), puis reviennent d'un coup à leur place finale : un élément qui
     apparaît ne compte pas comme un décalage. Fin : cadeaux resynchronisés (ou 1,2 s) et 280 ms sans changement dans
     le tiroir ; 2,2 s au plus. */
  var enTransition = false;
  function transitionTiroir(apres) {
    var d = document.getElementById('moonbundle-cart-drawer');
    if (!d || enTransition) { if (apres) apres(); return; }
    enTransition = true;
    var racine = document.documentElement, debut = Date.now(), calme = null, cadeaux = false, obs = null, plafond = null;
    function fin() {
      if (!enTransition) return;
      enTransition = false;
      if (obs) obs.disconnect();
      clearTimeout(calme); clearTimeout(plafond);
      window.removeEventListener('moonbundle-cart-updated', surCadeaux);
      racine.classList.remove('nk-pv-transition');
      if (apres) apres();
    }
    function relancer() {
      clearTimeout(calme);
      calme = setTimeout(function () { if (cadeaux || Date.now() - debut > 1200) fin(); else relancer(); }, 280);
    }
    function surCadeaux(e) { if (e && e.detail && e.detail.caller === 'progressive-gifts') { cadeaux = true; relancer(); } }
    racine.classList.add('nk-pv-transition');
    window.addEventListener('moonbundle-cart-updated', surCadeaux);
    obs = new MutationObserver(relancer);
    obs.observe(d, { childList: true, subtree: true, characterData: true });
    plafond = setTimeout(fin, 2200);
    relancer();
  }

  /* le tiroir se redessine avec le panier reçu (écouteur de Moon Bundles sur window) ; « cart:refresh » est l'un
     des événements de thème que suivent les cadeaux progressifs : ils se resynchronisent (paliers de 39 et 59 €) */
  function rafraichir(panier, apres) {
    var ok = panier && Array.isArray(panier.items);
    if (ok) majCompteur(panier);
    transitionTiroir(apres);
    try {
      window.dispatchEvent(new CustomEvent('moonbundle-cart-updated', { detail: ok ? { cart: panier, caller: 'nkosi-panier-vide' } : { caller: 'nkosi-panier-vide' } }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('nkosi:cart:added', { detail: { source: 'panier-vide' } }));
    } catch (x) {}
  }

  /* le bouton disparaît avec l'état vide : le focus clavier passe sur la ligne ajoutée (ou la croix du tiroir) */
  function refocaliser(b) {
    if (b.isConnected || (document.activeElement && document.activeElement !== document.body)) return;
    var cible = document.querySelector('#moonbundle-cart-drawer .moonbundle-cart-item a[href], #moonbundle-cart-drawer .moonbundle-cart-drawer-close');
    if (cible) { try { cible.focus({ preventScroll: true }); } catch (x) {} }
  }

  function ajouter(b) {
    if (b.getAttribute('aria-busy') === 'true') return;
    var lib = b.querySelector('[data-nk-pv-t]');
    var avaitFocus = document.activeElement === b;
    function etat(cle) {
      b.setAttribute('data-nk-pv-etat', cle);
      if (lib) { lib.setAttribute('data-nk-pv-t', cle === 'ok' ? 'ajoute' : 'erreur'); lib.textContent = t(cle === 'ok' ? 'ajoute' : 'erreur'); }
    }
    b.setAttribute('aria-busy', 'true');
    b.removeAttribute('data-nk-pv-etat');
    /* moonbundle_ignore=true : sans ce paramètre, les cadeaux progressifs de Moon Bundles interceptent l'ajout,
       ferment le tiroir et ouvrent leur fenêtre « Ajouté à votre panier ». Ici le client reste dans le tiroir. */
    fetch(RACINE + 'cart/add.js?moonbundle_ignore=true', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-nk-pv-ajout')), quantity: 1 }] })
    }).then(function (r) {
      if (!r || !r.ok) throw new Error('HTTP ' + (r && r.status));
      etat('ok');
      var apres = avaitFocus ? function () { refocaliser(b); } : null;
      return fetch(RACINE + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r2) { return r2.json(); })
        .then(function (panier) { rafraichir(panier, apres); }, function () { rafraichir(null, apres); });
    }).catch(function () {
      etat('erreur');
    }).then(function () {
      b.removeAttribute('aria-busy');
    });
  }

  function brancher(bloc) {
    var r = bloc.querySelector('[data-nk-pv-rangee]');
    var attente = false;
    if (r) {
      r.addEventListener('scroll', function () {
        if (attente) return;
        attente = true;
        requestAnimationFrame(function () { attente = false; majNav(bloc); });
      }, { passive: true });
    }
    /* écoute sur le bloc lui-même : le tiroir peut arrêter la propagation des clics */
    bloc.addEventListener('click', function (e) {
      var cible = e.target;
      if (!cible || !cible.closest) return;
      var nav = cible.closest('[data-nk-pv-nav]');
      if (nav && r) {
        var pas = Math.max(160, Math.round(r.clientWidth * 0.8));
        r.scrollBy({ left: nav.getAttribute('data-nk-pv-nav') === '-1' ? -pas : pas, behavior: 'smooth' });
        return;
      }
      var b = cible.closest('button[data-nk-pv-ajout]');
      if (b) { e.preventDefault(); ajouter(b); }
    });
    majNav(bloc);
  }

  function poser() {
    var d = document.getElementById('moonbundle-cart-drawer');
    if (!d || !d.classList.contains('open')) return;
    var vide = d.querySelector('.moonbundle-cart-empty');
    if (!vide || vide.querySelector('[data-nk-pv]')) return;
    var frag = construire();
    var bloc = frag.querySelector('[data-nk-pv]');
    if (!bloc) return;
    vide.classList.add('nk-pv-hote');
    vide.appendChild(frag);
    brancher(bloc);
  }

  /* le tiroir se monte dans body et se redessine à l'ouverture et à chaque changement du panier :
     le rappel tombe avant l'affichage suivant, le bloc est donc là dès la première image du tiroir ouvert */
  new MutationObserver(poser).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  poser();
})();
/* fin du module « Tiroir du panier vide » */

/* =============================================
   Product Page - Dual Sticky Columns v2
   Shorter column stays pinned, taller scrolls.
   No white space on either side.
   Date: 2026-04-10
   ============================================= */
(function() {
  'use strict';
  if (window.innerWidth < 750) return;

  function initDualSticky() {
    var row = document.querySelector('.main-product-section > .row.no-gutters');
    if (!row) return;

    var leftCol = row.querySelector(':scope > .col-md-6:first-child');
    var rightCol = row.querySelector(':scope > .col-md-6:last-child');
    if (!leftCol || !rightCol) return;

    var headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 60;
    var gap = 16;
    var topOffset = headerH + gap;

    function update() {
      var leftH = leftCol.scrollHeight;
      var rightH = rightCol.scrollHeight;
      var vh = window.innerHeight;

      if (leftH <= rightH) {
        // Left is shorter: left stays sticky at top, right scrolls
        leftCol.style.position = 'sticky';
        leftCol.style.top = topOffset + 'px';
        leftCol.style.alignSelf = 'flex-start';
        rightCol.style.position = 'relative';
        rightCol.style.top = 'auto';
        rightCol.style.alignSelf = 'auto';
      } else {
        // Right is shorter: right stays sticky at top, left scrolls
        rightCol.style.position = 'sticky';
        rightCol.style.top = topOffset + 'px';
        rightCol.style.alignSelf = 'flex-start';
        leftCol.style.position = 'relative';
        leftCol.style.top = 'auto';
        leftCol.style.alignSelf = 'auto';
      }

      // If the shorter column is taller than viewport, make it sticky at bottom
      var shorterCol = (leftH <= rightH) ? leftCol : rightCol;
      var shorterH = Math.min(leftH, rightH);
      if (shorterH > vh - topOffset) {
        shorterCol.style.top = (vh - shorterH - gap) + 'px';
      }
    }

    update();
    window.addEventListener('resize', update);
    // Re-check after images load
    window.addEventListener('load', function() { setTimeout(update, 500); });
    // Re-check after variant changes (images may change height)
    document.addEventListener('variant:changed', function() { setTimeout(update, 300); });
    // Also observe height changes
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(function() { update(); }).observe(leftCol);
      new ResizeObserver(function() { update(); }).observe(rightCol);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(initDualSticky, 500); });
  } else {
    setTimeout(initDualSticky, 500);
  }
})();


/* =============================================
   Cart PAGE - Upsell Meilleures Ventes + Reassurance
   Injected under cart items on /cart page
   Date: 2026-04-10
   ============================================= */
(function() {
  'use strict';

  function injectCartPageUpsell() {
    if (!window.location.pathname.includes('/cart')) return;
    if (document.querySelector('.nkosi-cart-page-reassurance')) return;

    var cartWrapper = document.querySelector('[data-cart-wrapper], .cart-section, .main-cart');
    if (!cartWrapper) return;

    // Find the submit/checkout area
    var checkoutArea = cartWrapper.querySelector('.cart-cta, .cart-footer, .cart-actions, [name="checkout"], .cart-btn-container, .cart-subtotal-section');
    var nkReassure = cartWrapper.querySelector('[data-nk-reassurance]');
    if (nkReassure) checkoutArea = nkReassure;
    var insertPoint = checkoutArea || cartWrapper;

    fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'collections/meilleures-ventes/products.json?limit=8') /* 03/11/2026 : adresse dans la langue de la page, titres traduits */
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (!data.products || data.products.length === 0) return;

        var html = '<div class="nkosi-cart-page-reassurance">';
        // NKOSI 2026-09-17 : bandeau reassurance et badge avis retires, remplaces par le snippet Liquid nkosi-cart-reassurance (textes alignes sur les politiques, note Judge.me en direct)

        // Best sellers grid
        html += '<h6 class="nkosi-cart-page-reco-title"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" style="vertical-align:-2px;margin-right:5px;"><path d="M8 1.333l2.06 4.174 4.607.67-3.334 3.25.787 4.586L8 11.847l-4.12 2.166.787-4.586L1.333 6.177l4.607-.67L8 1.333z" fill="#F29E24"/></svg>' + ({ en: 'Best sellers', de: 'Bestseller', it: 'I più venduti' }[(document.documentElement.lang || 'fr').slice(0, 2)] || 'Meilleures ventes') + '</h6>';
        html += '<div class="nkosi-cart-page-reco-grid">';
        data.products.forEach(function(p) {
          var img = p.images && p.images[0] ? p.images[0].src.replace(/(\.[a-z]+)\?/, '_300x300$1?') : '';
          var price = (p.variants[0].price / 1).toFixed(2).replace('.', ',') + ' \u20ac';
          html += '<a href="' + ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'products/' + p.handle + '" class="nkosi-cart-page-reco-card">' +
            (img ? '<img src="' + img + '" alt="' + p.title.replace(/"/g, '') + '" loading="lazy">' : '') +
            '<span class="reco-name" title="' + p.title.replace(/"/g, '&quot;') + '"' + (p.title.split(', ').length > 2 ? ' data-nk-court="' + (p.title.split(', ')[0] + ', ' + p.title.split(', ').pop()).replace(/"/g, '&quot;') + '"' : '') + '>' + p.title + '</span>' + // série 10 : forme courte si le titre dépasse (nkosi-ux-ui-2026-11.js)
            '<span class="reco-price">' + price + '</span>' +
          '</a>';
        });
        html += '</div></div>';

        if (checkoutArea) {
          checkoutArea.insertAdjacentHTML('afterend', html);
        } else {
          insertPoint.insertAdjacentHTML('beforeend', html);
        }
      })
      .catch(function() {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(injectCartPageUpsell, 1000); });
  } else {
    setTimeout(injectCartPageUpsell, 1000);
  }
})();

/* =============================================
   Collection Page - JS Sticky Filters
   Fixes overflow:hidden ancestors breaking CSS sticky
   Date: 2026-04-10
   ============================================= */
(function() {
  'use strict';
  if (window.innerWidth < 750) return;

  function initStickyFilters() {
    var sidebar = document.getElementById('filterSideBar');
    if (!sidebar) return;

    var parent = sidebar.parentElement;
    if (!parent) return;

    // Fix all ancestors: remove overflow:hidden that breaks sticky
    var el = sidebar.parentElement;
    while (el && el !== document.body) {
      var cs = getComputedStyle(el);
      if (cs.overflow === 'hidden' || cs.overflowY === 'hidden' || cs.overflowX === 'hidden') {
        el.style.overflow = 'visible';
      }
      el = el.parentElement;
    }

    // Ensure parent is flex with start alignment
    var parentCS = getComputedStyle(parent);
    if (parentCS.display !== 'flex' && parentCS.display !== 'grid') {
      parent.style.display = 'flex';
      parent.style.flexWrap = 'wrap';
    }
    parent.style.alignItems = 'flex-start';

    // Apply sticky to sidebar
    var headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 60;
    sidebar.style.position = 'sticky';
    sidebar.style.top = (headerH + 15) + 'px';
    sidebar.style.alignSelf = 'flex-start';
    sidebar.style.maxHeight = 'calc(100vh - ' + (headerH + 30) + 'px)';
    sidebar.style.overflowY = 'auto';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(initStickyFilters, 500); });
  } else {
    setTimeout(initStickyFilters, 500);
  }
  // Re-apply after AJAX collection loading
  document.addEventListener('collection:loaded', function() { setTimeout(initStickyFilters, 500); });
  window.addEventListener('load', function() { setTimeout(initStickyFilters, 1000); });
})();


/* ========================================
   Quick Add - Quantity buttons handler
   Theme JS doesn't bind to dynamically injected
   popup content, so we handle +/- clicks here.
   Date: 2026-04-10
   ======================================== */
(function () {
  "use strict";
  document.addEventListener("click", function (evt) {
    var btn = evt.target.closest(".quantity-button");
    if (!btn) return;
    var popup = btn.closest("#quick-add-popup");
    if (!popup) return;
    /* Stop theme handler from also firing (prevents double-increment) */
    evt.stopImmediatePropagation();
    var nkQty = btn.closest(".quantity");
    var input = nkQty ? nkQty.querySelector('input[name="quantity"]') : null;
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    var min = parseInt(input.getAttribute("min"), 10) || 1;
    if (btn.classList.contains("quantity-up")) {
      input.value = val + 1;
    } else if (btn.classList.contains("quantity-down")) {
      input.value = Math.max(min, val - 1);
    }
  }, true);
})();

/* ========================================
   Quick Add - Moon Bundle discount tiers
   Fetches product page, extracts bundle offers,
   displays discount tiers next to FORMAT selector.
   Date: 2026-04-10
   ======================================== */
(function () {
  "use strict";
  var TIERS_CLASS = "nkosi-qa-discount-tiers";

  /* Watch for popup opening via MutationObserver */
  var popup = document.getElementById("quick-add-popup");
  if (!popup) return;

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].attributeName === "class" && popup.classList.contains("show")) {
        loadDiscountTiers();
        break;
      }
    }
  });
  observer.observe(popup, { attributes: true });

  function loadDiscountTiers() {
    /* Find product URL from the injected content */
    var productInfo = popup.querySelector("product-info[data-url]");
    if (!productInfo) return;
    var url = productInfo.getAttribute("data-url");
    if (!url) return;
    /* Clean URL (remove tracking params) */
    url = url.split("?")[0];

    /* Don't re-fetch if tiers already shown for this product */
    var existing = popup.querySelector("." + TIERS_CLASS);
    if (existing && existing.getAttribute("data-product-url") === url) return;
    if (existing) existing.remove();

    /* Fetch product page to get Moon Bundle data */
    fetch(url, { credentials: "same-origin" })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var match = html.match(/bundle='([^']+)'/);
        if (!match) return;
        try {
          var decoded = match[1]
            .replace(/&quot;/g, '"')
            .replace(/&amp;/g, "&")
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">")
            .replace(/&#39;/g, "'")
            .replace(/&#x2F;/g, "/");
          var bundle = JSON.parse(decoded);
          var offers = bundle.configs && bundle.configs[0] && bundle.configs[0].offers;
          if (!offers || offers.length < 2) return;
          renderTiers(offers, url);
        } catch (e) { /* silently fail */ }
      });
  }

  function renderTiers(offers, url) {
    var target = popup.querySelector(".product-option-selector");
    if (!target) {
      /* Fallback: insert after the price */
      target = popup.querySelector(".quick-add-popup-content-body");
    }
    if (!target) return;

    /* Build tiers HTML - only show offers with actual discounts */
    var lines = [];
    for (var i = 0; i < offers.length; i++) {
      var o = offers[i];
      if (o.discount === "none" || !o.discountValue) continue;
      lines.push(
        '<span class="nkosi-qa-tier">' +
          '<strong>' + o.qty + ' unit\u00e9s</strong> ' +
          '&rarr; -' + o.discountValue + '%' +
        '</span>'
      );
    }
    if (!lines.length) return;

    var el = document.createElement("div");
    el.className = TIERS_CLASS;
    el.setAttribute("data-product-url", url);
    el.innerHTML = '<span class="nkosi-qa-tiers-label">Remises volume :</span> ' + lines.join(" ");
    target.after(el);
  }
})();

/* ========================================
   Quick Add - Fast handler override
   Bypasses theme's slow sequential flow:
   POST /cart/add.js → getJSON → .load() → setTimeout(1000)
   Replaced by: fetch → instant popup close → buildCart
   Date: 2026-04-10
   ======================================== */
(function () {
  "use strict";

  document.addEventListener(
    "click",
    function (evt) {
      var btn = evt.target.closest(".Sd_addProduct");
      if (!btn) return;
      var popup = btn.closest("#quick-add-popup");
      if (!popup) return;

      evt.preventDefault();
      evt.stopImmediatePropagation();

      var form = btn.closest("form");
      if (!form) return;

      /* Grab quantity BEFORE closing popup (input is outside <form>) */
      var qtyInput = popup.querySelector('input[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      btn.classList.add("is-loading");

      /* Prepare drawer immediately */
      var drawerBody = document.querySelector("[data-drawer-body]");
      var sideDrawer = document.querySelector("[data-side-drawer]");
      if (drawerBody && typeof preLoadLoadGif !== "undefined") {
        drawerBody.innerHTML = preLoadLoadGif;
      }
      if (sideDrawer) {
        sideDrawer.className = "yv_side_drawer_wrapper";
        sideDrawer.id = "mini__cart";
        sideDrawer.classList.add("mini_cart");
        var titleEl = sideDrawer.querySelector("[data-drawer-title]");
        if (titleEl && typeof cartTitleLabel !== "undefined") {
          titleEl.innerHTML = cartTitleLabel;
        }
      }

      /* Close popup instantly - kill CSS transition */
      popup.style.transition = "none";
      var dialog = popup.querySelector(".popup-dialog");
      if (dialog) dialog.style.transition = "none";
      popup.classList.remove("show");
      var bodyEl = popup.querySelector("[quick-add-body]");
      if (bodyEl) bodyEl.innerHTML = "";
      document.body.classList.remove("quick-add-popup-open", "quickview-open");
      requestAnimationFrame(function () {
        popup.style.transition = "";
        if (dialog) dialog.style.transition = "";
      });

      /* Open cart drawer */
      document.body.classList.add("side_Drawer_open", "yv_side_Drawer_open");
      var overlay = document.querySelector(".wrapper-overlay");
      if (overlay) overlay.style.display = "block";

      /* POST /cart/add.js via fetch - include quantity explicitly */
      var formData = new FormData(form);
      formData.set("quantity", qty);
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData).toString(),
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          var alert = document.getElementById("addToCartAlert");
          if (alert) try { alert.play(); } catch (e) {}
          if (typeof hapticFeedbackStatus !== "undefined" && hapticFeedbackStatus) {
            if (navigator.vibrate) navigator.vibrate(500);
          }
          if (typeof jQuery !== "undefined" && typeof buildCart === "function") {
            jQuery.getJSON("/cart.js", function (cart) {
              buildCart(cart, false);
              btn.classList.remove("is-loading");
            });
          }
        })
        .catch(function (err) {
          console.error("NKOSI Quick Add error:", err);
          btn.classList.remove("is-loading");
        });
    },
    true
  );
})();



/* =============================================
   NKOSI FIX: Destroy Flickity on product grids
   Flickity applies inline position:absolute which
   overrides CSS. This script destroys Flickity on
   product card containers and forces horizontal
   scroll layout.
   Date: 2026-04-14
   ============================================= */
(function() {
  "use strict";

  var SELECTORS = [
    ".collection-product-section .yv-collection-product-grid",
    ".collection-product-section .yv-tabbed-collection-filter-items",
    ".product-page-recommendations .yv-recent-product-grid",
    ".new-arrival-section .yv-collection-product-grid",
    ".recent-product-section .yv-recent-product-grid"
  ];

  function destroyFlickityAndFix(el) {
    /* Destroy Flickity instance if it exists */
    if (el.flickityInstance || (typeof Flickity !== "undefined" && Flickity.data(el))) {
      try {
        var flkty = el.flickityInstance || Flickity.data(el);
        flkty.destroy();
      } catch(e) { /* ignore */ }
    }

    /* Remove Flickity classes */
    el.classList.remove("flickity-enabled", "is-draggable");

    /* Remove flickity-viewport and flickity-slider wrappers */
    var viewport = el.querySelector(".flickity-viewport");
    var slider = el.querySelector(".flickity-slider");

    if (slider && viewport) {
      /* Move all cards out of slider > viewport back to main container */
      var cards = slider.querySelectorAll(":scope > .yv-product-card");
      cards.forEach(function(card) {
        /* Remove ALL inline styles set by Flickity */
        card.style.cssText = "";
        el.appendChild(card);
      });
      /* Remove the flickity wrappers */
      viewport.remove();
    } else if (slider) {
      var cards2 = slider.querySelectorAll(":scope > .yv-product-card");
      cards2.forEach(function(card) {
        card.style.cssText = "";
        el.appendChild(card);
      });
      slider.remove();
    }

    /* Remove any remaining flickity buttons */
    el.querySelectorAll(".flickity-button, .flickity-page-dots").forEach(function(btn) {
      btn.remove();
    });

    /* Force the container to horizontal scroll flex */
    el.style.cssText = "display:flex!important;flex-wrap:nowrap!important;gap:12px!important;overflow-x:auto!important;overflow-y:hidden!important;scroll-behavior:smooth;-webkit-overflow-scrolling:touch;margin:0!important;padding-bottom:4px;";

    /* Force each visible card to proper size */
    el.querySelectorAll(".yv-product-card").forEach(function(card) {
      if (card.classList.contains("filter-slide") && !card.classList.contains("active")) {
        card.style.display = "none";
        return;
      }
      card.style.cssText = "position:static!important;transform:none!important;left:auto!important;flex:0 0 calc((100% - 48px)/5)!important;min-width:180px!important;max-width:280px!important;padding:0!important;margin-bottom:0!important;opacity:1!important;";
    });

    /* Remove data-flickity-slider attribute to prevent re-init */
    el.removeAttribute("data-flickity-slider");
  }

  function fixAllGrids() {
    SELECTORS.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) {
        /* Only fix if Flickity is active or was active */
        if (el.classList.contains("flickity-enabled") ||
            el.querySelector(".flickity-viewport") ||
            el.querySelector(".flickity-slider") ||
            el.hasAttribute("data-flickity-slider")) {
          destroyFlickityAndFix(el);
        }
      });
    });
  }

  /* Run on DOMContentLoaded */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() {
      setTimeout(function() { fixAllGrids(); observeContainers(); }, 500);
    });
  } else {
    setTimeout(function() { fixAllGrids(); observeContainers(); }, 500);
  }

  /* Also run on tab click (for tabbed collections) */
  document.addEventListener("click", function(e) {
    var tabBtn = e.target.closest(".yv-tab-link, .yv-tab-item");
    if (tabBtn) {
      setTimeout(function() { fixAllGrids(); observeContainers(); }, 100);
      setTimeout(fixAllGrids, 500);
      setTimeout(fixAllGrids, 1000);
    }
  });

  /* B5 2026-09-06 : observateur limite aux conteneurs de SELECTORS (plus document.documentElement),
     et filtre sur "class" seul : nos propres ecritures de style ne redeclenchent plus la boucle. */
  var observedGrids = [];
  function observeContainers() {
    SELECTORS.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) {
        if (observedGrids.indexOf(el) !== -1) { return; }
        observedGrids.push(el);
        new MutationObserver(function(mutations) {
          var needsFix = false;
          mutations.forEach(function(m) {
            var target = m.target;
            if (target.classList && (
              target.classList.contains("flickity-enabled") ||
              target.classList.contains("flickity-viewport") ||
              target.classList.contains("flickity-slider")
            )) {
              needsFix = true;
            }
          });
          if (needsFix) {
            setTimeout(fixAllGrids, 200);
          }
        }).observe(el, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ["class"]
        });
      });
    });
  }

})();


/* =============================================
   NKOSI Accent Fixer - Force correct accents in cart reassurance
   Date: 2026-04-21
   Fixes: "securise" -> "sécurisé", "rembourse" -> "remboursé"
   ============================================= */
(function(){
  'use strict';
  var fixes = [
    ['Paiement securise', 'Paiement s\u00e9curis\u00e9'],
    ['Paiement 100% securise', 'Paiement 100% s\u00e9curis\u00e9'],
    ['Satisfait ou rembourse', 'Satisfait ou rembours\u00e9']
  ];
  function fixAccents() {
    var els = document.querySelectorAll('.nkosi-cart-reassurance span, .nkosi-reassurance-item span, .cart-drawer span, [class*="reassurance"] span');
    els.forEach(function(el) {
      fixes.forEach(function(pair) {
        if (el.textContent.trim() === pair[0]) {
          el.textContent = pair[1];
        }
      });
    });
  }
  // Run on DOM changes (cart drawer opens dynamically)
  /* G28 2026-09-08 : anti-rebond 250 ms et suppression de l intervalle permanent de 2 s (audit performance) */
  var nkAccentsTimer = null;
  var observer = new MutationObserver(function() { if (nkAccentsTimer) { clearTimeout(nkAccentsTimer); } nkAccentsTimer = setTimeout(fixAccents, 250); });
  observer.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', fixAccents);
})();


/* ------------------------------------------------------------------
   NKOSI 2026-09-08 : reparation de l estimateur de frais de livraison du panier.
   Le theme lie le bouton « Obtenir des estimations » dans un setTimeout(0) qui sort
   tout de suite si Shopify.CountryProvinceSelector n est pas encore charge. Sur la
   production la librairie arrive apres, donc le bouton restait mort au premier
   chargement, et il le redevenait apres chaque rafraichissement AJAX du panier.
   On attend que la librairie soit la, on remplace le bouton par un clone (ce qui
   retire tout ecouteur deja pose, donc pas de double requete) et on relance la
   liaison du theme. Un controle leger toutes les 2 s rattrape les re-rendus.
------------------------------------------------------------------ */
/* Recopie les provinces depuis le select cache : sans elles, l Italie, l Espagne,
   l Irlande et le Portugal repondent « Selectionner une province » et l estimation echoue. */
function nkEstimProvinces() {
  var pays = document.getElementById('shippingCountry');
  var tous = document.getElementById('nkTousPays');
  if (!pays || !tous || pays.getAttribute('data-nk-prov') === 'ok') return;
  var parNom = {};
  for (var i = 0; i < tous.options.length; i++) {
    parNom[tous.options[i].text.trim()] = tous.options[i].getAttribute('data-provinces') || '[]';
  }
  for (var j = 0; j < pays.options.length; j++) {
    var o = pays.options[j];
    o.setAttribute('data-provinces', parNom[o.text.trim()] || '[]');
  }
  pays.setAttribute('data-nk-prov', 'ok');
}

(function nkEstimBind() {
  if (window.location.pathname.indexOf('/cart') === -1) return;
  var essais = 0;
  function lier() {
    var btn = document.getElementById('getShippingEstimates');
    if (!btn) { if (++essais < 40) setTimeout(lier, 250); return; }
    if (btn.getAttribute('data-nk-estim') === 'ok') return;
    if (!(window.Shopify && window.Shopify.CountryProvinceSelector && typeof window.shippingEstimates === 'function')) {
      if (++essais < 40) setTimeout(lier, 250);
      return;
    }
    nkEstimProvinces();
    var neuf = btn.cloneNode(true);
    btn.parentNode.replaceChild(neuf, btn);
    neuf.setAttribute('data-nk-estim', 'ok');
    try { window.shippingEstimates(); } catch (e) {}
  }
  function surveiller() {
    var btn = document.getElementById('getShippingEstimates');
    if (btn && btn.getAttribute('data-nk-estim') !== 'ok') { essais = 0; lier(); }
  }
  function forcer() {
    var btn = document.getElementById('getShippingEstimates');
    if (btn) { btn.removeAttribute('data-nk-estim'); }
    essais = 0;
    lier();
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', lier); } else { lier(); }
  /* le theme tente sa propre liaison dans un setTimeout : on repasse une fois apres pour
     ne garder qu un seul ecouteur, sinon un clic declenche deux estimations identiques. */
  setTimeout(forcer, 3000);
  setInterval(surveiller, 2000);
})();


/* G29 2026-09-08 : format francais des montants.
   Le format de la boutique est fige a « €{{amount_with_comma_separator}} » : Shopify a retire
   l editeur de format des boutiques sous Markets et aucune mutation d API ne l expose.
   Chaque montant sort enveloppe dans <span class="trans-money"> : on y remet le symbole apres
   le nombre, avec une espace fine insecable, conformement a la typographie francaise.
   L anglais est laisse tel quel (la convention y place le symbole avant le nombre). */
(function () {
  var FINE = ' ';
  var langue = (document.documentElement.getAttribute('lang') || 'fr').slice(0, 2).toLowerCase();
  if (langue === 'en') { return; }
  function nkMontantsFr(racine) {
    var noeuds = (racine || document).querySelectorAll('.trans-money');
    for (var i = 0; i < noeuds.length; i++) {
      var t = (noeuds[i].textContent || '').trim();
      if (t.charAt(0) !== '€') { continue; }
      var corps = t.slice(1).trim();
      var suffixe = '€';
      if (/\s(EUR|eur)$/.test(corps)) { corps = corps.replace(/\s(EUR|eur)$/, ''); suffixe = 'EUR'; }
      if (!corps) { continue; }
      noeuds[i].textContent = corps + FINE + suffixe;
    }
  }
  function demarrer() {
    nkMontantsFr();
    /* Regulation par palier plutot qu anti-rebond : sur une page qui mute en continu
       (tiroir panier, selecteur de variante, widgets), un anti-rebond peut ne jamais
       se declencher. Ici une passe au plus toutes les 200 ms, plus une passe de fin. */
    var dernier = 0, fin = null;
    function planifier() {
      var t = Date.now();
      if (t - dernier > 200) { dernier = t; nkMontantsFr(); }
      if (fin) { clearTimeout(fin); }
      fin = setTimeout(function () { dernier = Date.now(); nkMontantsFr(); }, 220);
    }
    new MutationObserver(planifier).observe(document.body, { childList: true, subtree: true, characterData: true });
    [400, 1200, 2500, 5000].forEach(function (d) { setTimeout(function () { nkMontantsFr(); }, d); });
    ['shopify:section:load', 'variant:change', 'cart:refresh', 'cart:updated'].forEach(function (e) {
      document.addEventListener(e, function () { setTimeout(nkMontantsFr, 60); });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();


/* --- Marché Collage S3 (27/09/2026, demande d'Antonio) : textes Moon Bundles sans émojis ---
   Les titres des lots saisis dans l'application portent des émojis (« … faites fondre l'addition 💰🔥 ») et le titre des
   paliers de quantité ne dit pas ce qu'il propose. Ici, sur la copie du thème seulement : on retire les émojis des textes
   Moon Bundles dès qu'ils s'affichent, et ce titre devient « Plus vous en prenez, moins vous payez », dans la langue du
   site. À la publication, corriger aussi les titres dans l'application (28 lots), puis retirer ce bloc s'il ne sert plus. */
(function () {
  "use strict";
  var EMOJI = /(?:\p{Extended_Pictographic}|[\u{1F3FB}-\u{1F3FF}\u{FE0F}\u{200D}\u{20E3}])/gu;
  var langue = (document.documentElement.getAttribute("lang") || "fr").slice(0, 2).toLowerCase();
  var PALIERS = {
    fr: "Plus vous en prenez, moins vous payez",
    en: "The more you take, the less you pay",
    de: "Je mehr Sie nehmen, desto weniger zahlen Sie",
    it: "Più ne prendete, meno pagate"
  };
  /* le titre saisi dans l'application, dans les traductions de Moon Bundles (FR, EN, DE, IT) */
  var ANCIEN = /fondre l.addition|ajoutez des saveurs|add flavou?rs|melt the bill|aromen hinzu|senken sie die rechnung|aggiung\w* (?:dei |i |del )?sapori|sciogli\w* il conto/i;
  var CIBLES = ".moonbundle-title, [class*='moonbundle'] [class*='title'], [class*='moonbundle'] [class*='badge'], [class*='moonbundle'] [class*='label'], [class*='moonbundle-pg'] p, [class*='moonbundle-pg'] span";
  var prevu = false;

  function nettoyerTexte(el) {
    var marcheur = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = marcheur.nextNode())) {
      var t = n.nodeValue;
      if (!t || !EMOJI.test(t)) { EMOJI.lastIndex = 0; continue; }
      EMOJI.lastIndex = 0;
      var propre = t.replace(EMOJI, "").replace(/\s{2,}/g, " ");
      if (propre !== t) n.nodeValue = propre;
    }
  }

  function nettoyer() {
    prevu = false;
    document.querySelectorAll(CIBLES).forEach(function (el) {
      nettoyerTexte(el);
      if (el.classList.contains("moonbundle-title") && el.children.length === 0 && ANCIEN.test(el.textContent)) {
        var nouveau = PALIERS[langue] || PALIERS.fr;
        if (el.textContent.trim() !== nouveau) el.textContent = nouveau;
      }
    });
  }

  function prevoir() {
    if (prevu) return;
    prevu = true;
    (window.requestAnimationFrame || setTimeout)(nettoyer);
  }

  function demarrer() {
    nettoyer();
    new MutationObserver(prevoir).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", demarrer);
  } else {
    demarrer();
  }
})();
